import React, { useEffect, useState } from 'react';
import {
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  CardMedia,
  Button,
  Box,
  Paper,
  Stack,
  useTheme,
} from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import NotificationsIcon from '@mui/icons-material/Notifications';
import EventIcon from '@mui/icons-material/Event';
import DescriptionIcon from '@mui/icons-material/Description';
import './Home.css';

const departments = [
  {
    name: 'कायदा सुव्यवस्था',
    icon: <i className="fas fa-scale-balanced"></i>, // Proper Law Icon
    submenu: [
      { name: 'पोलीस विभाग', icon: <i className="fas fa-shield-alt"></i> },
      { name: 'न्यायालय', icon: <i className="fas fa-gavel"></i> },
      { name: 'सुरक्षा उपाययोजना', icon: <i className="fas fa-user-shield"></i> },
    ],
  },
  {
    name: 'कुटुंब',
    icon: <i className="fas fa-users"></i>,
    submenu: [
      { name: 'परिवार कल्याण', icon: <i className="fas fa-heart"></i> },
      { name: 'महिला सशक्तिकरण', icon: <i className="fas fa-venus"></i> },
    ],
  },
  {
    name: 'शिक्षण',
    icon: <i className="fas fa-book-open"></i>, // Better Education Icon
    submenu: [
      { name: 'विद्यालय', icon: <i className="fas fa-school"></i> },
      { name: 'उच्च शिक्षण', icon: <i className="fas fa-university"></i> },
      { name: 'शिष्यवृत्ती', icon: <i className="fas fa-graduation-cap"></i> },
    ],
  },
  {
    name: 'कृषी',
    icon: <i className="fas fa-seedling"></i>,
    submenu: [
      { name: 'कृषी धोरणे', icon: <i className="fas fa-leaf"></i> },
      { name: 'सेंद्रिय शेती', icon: <i className="fas fa-tractor"></i> },
      { name: 'पीक विमा', icon: <i className="fas fa-file-invoice-dollar"></i> },
    ],
  },
  {
    name: 'सांस्कृतिक',
    icon: <i className="fas fa-theater-masks"></i>,
    submenu: [
      { name: 'संगीत', icon: <i className="fas fa-music"></i> },
      { name: 'कला', icon: <i className="fas fa-palette"></i> },
      { name: 'परंपरा', icon: <i className="fas fa-scroll"></i> },
    ],
  },
  {
    name: 'महसूल',
    icon: <i className="fas fa-landmark"></i>,
    submenu: [
      { name: 'भू-मालकी', icon: <i className="fas fa-map-marked-alt"></i> },
      { name: 'कर प्रणाली', icon: <i className="fas fa-coins"></i> },
      { name: 'ग्राम विकास', icon: <i className="fas fa-house-user"></i> },
    ],
  },
  {
    name: 'पर्यटन',
    icon: <i className="fas fa-globe-asia"></i>, // Correct Tourism Icon
    submenu: [
      { name: 'पर्यटन स्थळे', icon: <i className="fas fa-map"></i> },
      { name: 'हॉटेल्स', icon: <i className="fas fa-hotel"></i> },
      // { name: 'गाईड सेवा', icon: <i className="fas fa-user-tie"></i> },
    ],
  },
];

const Home: React.FC = () => {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null); // ✅ Fixed Type

  const newsItems = [
    {
      title: 'Gram Sabha Meeting Announcement',
      date: '2024-02-10',
      description: 'Monthly Gram Sabha meeting will be held at Grampanchayat Hall.',
    },
    {
      title: 'New Water Supply Project',
      date: '2024-02-08',
      description: 'Implementation of 24x7 water supply project has been approved.',
    },
    {
      title: 'Swachh Bharat Abhiyan',
      date: '2024-02-05',
      description: 'Village cleanliness drive scheduled for next weekend.',
    },
  ];

  const schemes = [
    {
      title: 'PM Awas Yojana',
      image: 'pmj2.png',
      description: 'Housing scheme for rural residents',
    },
    {
      title: 'MNREGA',
      image: 'mg.png',
      description: 'Employment guarantee scheme',
    },
    {
      title: 'Swachh Bharat Mission',
      image: 'swach2.png',
      description: 'Clean India Mission',
    },
  ];

  const carouselItems = [
    //{ src: '/as.jpg', alt: 'Image 1' },
    { src: '/function/f7.jpg', alt: 'Image 2',style: { objectFit: 'cover' } },
    { src: '/function/f9.jpg', alt: 'Image 2',style: { objectFit: 'cover' } },
    { src: '/function/f10.jpg', alt: 'Image 2',style: { objectFit: 'cover' } },
    { src: '/function/f11.jpg', alt: 'Image 2',style: { objectFit: 'cover' } },
    
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % carouselItems.length);
    }, 2000);

    return () => clearInterval(interval);
  }, [carouselItems.length]);

  return (
    <div>
     

      {/* Carousel */}
      <div className="carousel">
        <div style={{ width: '100%', overflow: 'hidden'  }}>
          <img src={carouselItems[currentIndex].src} alt={carouselItems[currentIndex].alt} style={{ height: '620px', width: '100%', objectFit: 'cover' }} />
        </div>
      </div>


        {/* Departments Navigation */}
      <Box className="departments-nav">
        {departments.map((dept, index) => (
          <Box
            key={index}
            className={`department-item ${index === 0 ? 'first-dept' : ''} ${index === departments.length - 1 ? 'last-dept' : ''}`}
            onMouseEnter={() => setHoveredIndex(index)}
            onMouseLeave={() => setHoveredIndex(null)}
          >
            <span className="dept-icon">{dept.icon}</span>
            <Typography variant="h6" className="dept-text">
              {dept.name}
            </Typography>

            {/* Submenu appears ABOVE the navigation */}
            {hoveredIndex === index && (
              <Box className={`submenu-container ${index === 0 ? 'first-submenu' : ''} ${index === departments.length - 1 ? 'last-submenu' : ''}`}>
                <Paper className="submenu-box">
                  <Grid container spacing={2}>
                    {dept.submenu.map((item, subIndex) => (
                      <Grid item xs={12} sm={4} key={subIndex} className="submenu-item-container">
                        <Button className="submenu-item">
                          {item.icon} <span className="submenu-text">{item.name}</span>
                        </Button>
                      </Grid>
                    ))}
                  </Grid>
                </Paper>
              </Box>
            )}
          </Box>
        ))}
      </Box>
      
    </div>
  );
};

export default Home;
